<template>
  <RatioSpacedContainer v-if="props.packages.length === 0">
    <Empty
      :text="props.emptyHint"
      :desc="_t('package.create_tip7')"
    ></Empty>
  </RatioSpacedContainer>

  <!--
    这里加一层的目的是当外层设置了高度时，如果高度超出了一个元素的高度
    会导致 grid 容器里面的元素（元素较少时）在垂直方向上会拉伸
  -->
  <div v-else>
    <div class="grid gap-3 pb-4 auto-grid-cols">
      <PkgCard
        v-for="pkg in props.packages"
        :key="pkg.id"
        :pkg="pkg"
        class="cursor-pointer"
        @edit="emit('edit', pkg.id)"
        @share-setting="emit('shareSetting', pkg.id)"
        @delete="emit('delete', pkg.id)"
        @remove-shelf="emit('removeShelf', pkg.id)"
        @click="onClick(pkg)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Empty from '@/components/Empty.vue'
import PkgCard from './PkgCard.vue'

import type { PackageBasic } from '@/api/package-source'

const props = defineProps<{
  packages: PackageBasic[]
  emptyHint: string
}>()

const emit = defineEmits<{
  edit: [number]
  shareSetting: [number]
  delete: [number]
  removeShelf: [number]
  click: [number]
}>()

function onClick(pkg: PackageBasic) {
  emit('click', pkg.id)
}
</script>

<style scoped>
.auto-grid-cols {
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
}
</style>
